import { createFeatureSelector, createSelector } from '@ngrx/store';

import { listTileReducerFactory } from '../../../pillar/dashboard/store/reducers/list-tile.reducerFactory';
import { TileState } from '../../../pillar/dashboard/store/state/TileState';

import { ModuleConfiguration } from '../../security.module.config';
import { userContextReducer } from './user-context.reducer';
import { IUserContext } from '../state/IUserContext';
import { RoleListModel } from '../../models/RoleListModel';
import { RoleModel } from '../../models/RoleModel';
import { IRolesContext } from '../state/IRolesContext';
import { rolesContextReducer } from './roles-context.reducer';
import { rolesReducer } from './roles.reducer';
import { supportTicketReducer } from "./support-ticket.reducer";
import { ISupportTicketState } from '../state/ISupportTicketState';

export interface SecurityState {
  userContext: IUserContext,
  roleState: TileState<RoleListModel, RoleModel>,
  rolesContextState: IRolesContext,
  supportTicketState: ISupportTicketState;
};

export const reducers = {
  userContext: userContextReducer,
  roleState: rolesReducer,
  rolesContextState: rolesContextReducer,
  supportTicketState: supportTicketReducer
};

export const getSecurityState = createFeatureSelector('security');
export const getUserContext = createSelector(getSecurityState, (s: SecurityState) => s.userContext);
export const getAvailableRoles = createSelector(getUserContext, (s: IUserContext) => s.availableRoles);

export const getUserContextIsAuthenticated = createSelector(getUserContext, (s: IUserContext) => s.isAuthenticated);
export const getUserContextErrors = createSelector(getUserContext, (s: IUserContext) => s.errors);
export const getUserContextLoading = createSelector(getUserContext, (s: IUserContext) => s.loading);
export const getUserContextSubmittingEntities = createSelector(getUserContext, (s: IUserContext) => s.submittingEntities);
export const getUserContextSubmittingEntitiesLoaded = createSelector(getUserContext, (s: IUserContext) => s.submittingEntitiesLoaded);
export const getUserContextUser = createSelector(getUserContext, (s: IUserContext) => s.user);

export const getRolesState = createSelector(getSecurityState, (s: SecurityState) => s.roleState);
export const getRoleList = createSelector(getRolesState, (s: TileState<RoleListModel, RoleModel>) => s.list);
export const getRoleListTotalCount = createSelector(getRolesState, (s: TileState<RoleListModel, RoleModel>) => s.totalCount);
export const getRoleListLoading = createSelector(getRolesState, (s: TileState<RoleListModel, RoleModel>) => s.loading);
export const getRoleListErrors = createSelector(getRolesState, (s: TileState<RoleListModel, RoleModel>) => s.errors);
export const getRoleSelection = createSelector(getRolesState, (s: TileState<RoleListModel, RoleModel>) => s.selected);
export const getRoleAssignedRoles = createSelector(getRoleSelection, (s: RoleModel) => s.includedRoles);
export const getRoleAssignedPermissions = createSelector(getRoleSelection, (s: RoleModel) => s.includedPermissions);

export const getRolesContext = createSelector(getSecurityState, (s: SecurityState) => s.rolesContextState);
export const getJobFunctions = createSelector(getRolesContext, (s: IRolesContext) => s.jobFunctions);
export const getTaskGroups = createSelector(getRolesContext, (s: IRolesContext) => s.taskGroups);
export const getTasks = createSelector(getRolesContext, (s: IRolesContext) => s.tasks);
export const getPermissions = createSelector(getRolesContext, (s: IRolesContext) => s.permissions);

export const getSupportTicketState = createSelector(getSecurityState, (s: SecurityState) => s.supportTicketState);
export const getSupportTicketInformation = createSelector(getSupportTicketState, (s: ISupportTicketState) => s.supportTicketInformation);



// WEBPACK FOOTER //
// ./src/app/security/store/reducers/index.ts